<template>
  <div>
    <h2>Uitslag Beroepentest</h2>
    <div class="outcome-wrapper">
      <div
        :key="index"
        v-for="(sortedCategory, index) in sortedCategories"
        class="text-outcome"
      >
        <div
          v-if="sortedCategory.score == 0"
          class="text-outcome-inner text-outcome-not-selected"
        >
          <h3>
            <span class="title-choice">
              {{ sortedCategory.title }}<br />
              (niet gekozen)
            </span>
          </h3>
          <div v-html="sortedCategory.text"></div>
          <ul>
            <li :key="i" v-for="(job, i) in sortedCategory.beroepen">
              {{ sortedCategory.beroepen[i] }}
            </li>
          </ul>
        </div>

        <div v-else class="text-outcome-inner">
          <h3>
            <span class="number-choice">{{ index + 1 }}<sup>e</sup></span>
            <span class="title-choice"
              >{{ sortedCategory.title }} <br />
              ({{ sortedCategory.score }} x gekozen)
            </span>
          </h3>
          <div v-html="sortedCategory.text"></div>
          <ul>
            <li :key="i" v-for="(job, i) in sortedCategory.beroepen">
              {{ sortedCategory.beroepen[i] }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scores: {
      type: Array
    },
    categories: {
      type: Array
    }
  },
  data() {
    return {
      sortedScores: [],
      sortedCategories: []
    };
  },
  methods: {
    sortCategoriesByScore() {
      // Sort scores first (DESC)
      this.sortedScores = this.scores.sort((a, b) =>
        a.score < b.score ? 1 : -1
      );
      // Loop through sorted scores
      this.scores.forEach(item => {
        // Find the category code in categories
        let arrayIndex = this.categories.findIndex(o => o.code == item.code);

        // Clone category with score attached
        let category = this.categories[arrayIndex];
        category["score"] = item.score;
        this.sortedCategories.push(category);
      });
    }
  },
  created() {
    this.sortCategoriesByScore();
  }
};
</script>
